import consts from 'constants/url';
import netpack from 'utils/netpack';
import actionConsts from 'constants/actions';

export const fetchIntermediateReportData = () => (dispatch) => {
    netpack(consts.INTERMEDIATE_REPORT_API)
        .get()
        .then((response) => {
            dispatch({
                type: actionConsts.INTERMEDIATE_REPORT_DATA,
                payload: response
            })
        });
    }
